export const portfolioData = [
  {
    Datetime: "2021-10-07 20:16:11",
    id: 19,
    Wallet: "0x7f...C63c",
    Name: "PolygonAutofarm",
    Blockchain: "Polygon",
    Platform: "Autofarm",
    Vault: "WETH-WBTC LP",
    Uses: "Sushi",
    BalanceOf: 0.0,
    PricePerFullShare: 1.0,
    Balance: 0.0,
    Reward: 0.0,
    RewardToken: null,
    LpTokens: null,
    LpTokensUsd: null,
    BalanceUsd: null,
    RewardTokensUsd: null,
    RewardUsd: null,
    TotalUsd: null,
  },
  {
    Datetime: "2021-10-17 14:03:04",
    id: 9,
    Wallet: "0xAf...135F",
    Name: "PolygonAaveUsdc",
    Blockchain: "Polygon",
    Platform: "Aave",
    Vault: "USDC",
    Uses: null,
    BalanceOf: 247.081312,
    PricePerFullShare: 1.0,
    Balance: 247.081312,
    Reward: 0.0,
    RewardToken: "wMatic",
    LpTokens: "0x2791bca1f2de4661ed88a30c99a7a9449aa84174",
    LpTokensUsd: "1",
    BalanceUsd: 247.081312,
    RewardTokensUsd: "1.51",
    RewardUsd: 0.0,
    TotalUsd: 247.081312,
  },
  {
    Datetime: "2021-10-17 14:03:04",
    id: 8,
    Wallet: "0xAf...135F",
    Name: "PolygonAaveUsdtDebt",
    Blockchain: "Polygon",
    Platform: "Aave",
    Vault: "UsdtDebt",
    Uses: null,
    BalanceOf: -139.406512,
    PricePerFullShare: 1.0,
    Balance: -139.406512,
    Reward: 0.0,
    RewardToken: "wMatic",
    LpTokens: "0xc2132d05d31c914a87c6611c10748aeb04b58e8f",
    LpTokensUsd: "1.01",
    BalanceUsd: -140.80057712,
    RewardTokensUsd: "1.51",
    RewardUsd: 0.0,
    TotalUsd: -140.80057712,
  },
  {
    Datetime: "2021-10-17 14:03:04",
    id: 7,
    Wallet: "0xAf...135F",
    Name: "PolygonAaveUsdt",
    Blockchain: "Polygon",
    Platform: "Aave",
    Vault: "USDT",
    Uses: null,
    BalanceOf: 258.513504,
    PricePerFullShare: 1.0,
    Balance: 258.513504,
    Reward: 0.0,
    RewardToken: "wMatic",
    LpTokens: "0xc2132d05d31c914a87c6611c10748aeb04b58e8f",
    LpTokensUsd: "1.01",
    BalanceUsd: 261.09863904,
    RewardTokensUsd: "1.51",
    RewardUsd: 0.0,
    TotalUsd: 261.09863904,
  },
  {
    Datetime: "2021-10-17 14:03:04",
    id: 6,
    Wallet: "0xAf...135F",
    Name: "PolygonBeefy",
    Blockchain: "Polygon",
    Platform: "Beefy",
    Vault: "MATIC | Aave",
    Uses: null,
    BalanceOf: 242.5721653574,
    PricePerFullShare: 1.0339128949,
    Balance: 250.7984897008,
    Reward: 0.0,
    RewardToken: null,
    LpTokens: "0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270",
    LpTokensUsd: "1.51",
    BalanceUsd: 378.7057194481,
    RewardTokensUsd: null,
    RewardUsd: 0.0,
    TotalUsd: 378.7057194481,
  },
  {
    Datetime: "2021-10-17 14:03:04",
    id: 10,
    Wallet: "0xcc...ba15",
    Name: "PolygonAaveUsdc",
    Blockchain: "Polygon",
    Platform: "Aave",
    Vault: "USDC",
    Uses: null,
    BalanceOf: 100.223139,
    PricePerFullShare: 1.0,
    Balance: 100.223139,
    Reward: 0.0,
    RewardToken: "wMatic",
    LpTokens: "0x2791bca1f2de4661ed88a30c99a7a9449aa84174",
    LpTokensUsd: "1",
    BalanceUsd: 100.223139,
    RewardTokensUsd: "1.51",
    RewardUsd: 0.0,
    TotalUsd: 100.223139,
  },
  {
    Datetime: "2021-10-17 14:03:04",
    id: 4,
    Wallet: "0xAf...135F",
    Name: "AvaxTraderJoe",
    Blockchain: "Avax",
    Platform: "TraderJoe",
    Vault: "USDT.e-DAI.e",
    Uses: null,
    BalanceOf: 0.0,
    PricePerFullShare: 1.0,
    Balance: 0.0,
    Reward: 2.4389478329,
    RewardToken: "JOE",
    LpTokens:
      "0xd586E7F844cEa2F87f50152665BCbc2C279D8d70,0xc7198437980c041c805A1EDcbA50c1Ce5db95118",
    LpTokensUsd: "1,1.01",
    BalanceUsd: 0.0,
    RewardTokensUsd: "2.12",
    RewardUsd: 5.1705694058,
    TotalUsd: 5.1705694058,
  },
  {
    Datetime: "2021-10-17 14:03:04",
    id: 5,
    Wallet: "0xAf...135F",
    Name: "CeloUbeswap",
    Blockchain: "Celo",
    Platform: "Ubeswap",
    Vault: "mcUSD-mcEUR",
    Uses: null,
    BalanceOf: 223.7529463789,
    PricePerFullShare: 1.0,
    Balance: 223.7529463789,
    Reward: 1.2458488818,
    RewardToken: "CELO,MOO,UBE",
    LpTokens:
      "0x64dEFa3544c695db8c535D289d843a189aa26b98,0xa8d0E6799FF3Fd19c6459bf02689aE09c4d78Ba7",
    LpTokensUsd: "0,0",
    BalanceUsd: 0.0,
    RewardTokensUsd: "6.14,1.38,1",
    RewardUsd: 10.6146324733,
    TotalUsd: 10.6146324733,
  },
  {
    Datetime: "2021-10-17 14:03:04",
    id: 17,
    Wallet: "0x7f...C63c",
    Name: "BscBeefy",
    Blockchain: "Avax",
    Platform: "Beefy",
    Vault: "WETH.e-AVAX LP",
    Uses: "Trader Joe",
    BalanceOf: 0.4996048755,
    PricePerFullShare: 1.0641097844,
    Balance: 0.5316344364,
    Reward: 0.0,
    RewardToken: null,
    LpTokens:
      "0x49D5c2BdFfac6CE2BFdB6640F4F80f226bc10bAB,FvwEAhmxKfeiG8SnEvq42hc6whRyY3EFYAvebMqDNDGCgxN5Z",
    LpTokensUsd: "3902.11,58.13",
    BalanceUsd: 1052.6999801297,
    RewardTokensUsd: null,
    RewardUsd: 0.0,
    TotalUsd: 1052.6999801297,
  },
  {
    Datetime: "2021-10-17 14:03:04",
    id: 18,
    Wallet: "0x7f...C63c",
    Name: "PolygonAutofarm",
    Blockchain: "Polygon",
    Platform: "Autofarm",
    Vault: "WETH-WBTC LP",
    Uses: "Quickswap",
    BalanceOf: 0.0000000011,
    PricePerFullShare: 1.0,
    Balance: 0.0000000011,
    Reward: 0.0,
    RewardToken: "pAUTO,wMatic",
    LpTokens:
      "0x7ceb23fd6bc0add59e62ac25578270cff1b9f619,0x1bfd67037b42cf73acf2047067bd4f2c47d9bfd6",
    LpTokensUsd: "3902.11,61372",
    BalanceUsd: 0.0000351936,
    RewardTokensUsd: "1199.49,1.51",
    RewardUsd: 0.0,
    TotalUsd: 0.0000351936,
  },
  {
    Datetime: "2021-10-17 14:03:04",
    id: 3,
    Wallet: "0xAf...135F",
    Name: "PolygonAutofarm",
    Blockchain: "Polygon",
    Platform: "Autofarm",
    Vault: "DAI-USDC-USDT LP (aave) | Curve",
    Uses: null,
    BalanceOf: 511.7312698168,
    PricePerFullShare: 1.0,
    Balance: 511.7312698168,
    Reward: 0.0,
    RewardToken: "pAUTO,wMatic",
    LpTokens:
      "0x8f3cf7ad23cd3cadbd9735aff958023239c6a063,0x2791bca1f2de4661ed88a30c99a7a9449aa84174,0xc2132d05d31c914a87c6611c10748aeb04b58e8f",
    LpTokensUsd: "1,1,1.01",
    BalanceUsd: 513.4370407162,
    RewardTokensUsd: "1199.49,1.51",
    RewardUsd: 0.0,
    TotalUsd: 513.4370407162,
  },
  {
    Datetime: "2021-10-17 14:03:05",
    id: 2,
    Wallet: "0x68...4ff6",
    Name: "BscAutofarm_2",
    Blockchain: "BSC",
    Platform: "Autofarm",
    Vault: "BUSD-WINGS LP",
    Uses: null,
    BalanceOf: 3.9828576456,
    PricePerFullShare: 1.0,
    Balance: 3.9828576456,
    Reward: 0.0003780436,
    RewardToken: "pAUTO",
    LpTokens:
      "0x0487b824c8261462f88940f97053e65bdb498446,0xe9e7cea3dedca5984780bafc599bd69add087d56",
    LpTokensUsd: "0.179788,1",
    BalanceUsd: 2.349463828,
    RewardTokensUsd: "1199.49",
    RewardUsd: 0.4534595544,
    TotalUsd: 2.8029233824,
  },
  {
    Datetime: "2021-10-17 14:03:05",
    id: 11,
    Wallet: "0x68...4ff6",
    Name: "BscBeefy",
    Blockchain: "BSC",
    Platform: "Beefy",
    Vault: "VAI-BUSD LP",
    Uses: "PancakeSwap",
    BalanceOf: 11.745532405,
    PricePerFullShare: 1.0955510799,
    Balance: 12.8678307097,
    Reward: 0.0,
    RewardToken: null,
    LpTokens:
      "0x4bd17003473389a42daf6a0a729f6fdb328bbbd7,0xe9e7cea3dedca5984780bafc599bd69add087d56",
    LpTokensUsd: "0.981365,1",
    BalanceUsd: 12.7479346971,
    RewardTokensUsd: null,
    RewardUsd: 0.0,
    TotalUsd: 12.7479346971,
  },
  {
    Datetime: "2021-10-17 14:03:05",
    id: 216,
    Wallet: "0x7f...C63c",
    Name: "BscMarsXms",
    Blockchain: "BSC",
    Platform: "Mars Ecosystem",
    Vault: "XMS",
    Uses: null,
    BalanceOf: 0.0,
    PricePerFullShare: 1.0,
    Balance: 0.0,
    Reward: 0.0,
    RewardToken: null,
    LpTokens: "0x7859b01bbf675d67da8cd128a50d155cd881b576",
    LpTokensUsd: "0.95287",
    BalanceUsd: 0.0,
    RewardTokensUsd: null,
    RewardUsd: 0.0,
    TotalUsd: 0.0,
  },
  {
    Datetime: "2021-10-17 14:03:05",
    id: 217,
    Wallet: "0x7f...C63c",
    Name: "BscAquaLp",
    Blockchain: "BSC",
    Platform: "Planet",
    Vault: "Planet LPs|Net-LP |? AQUA-BNB",
    Uses: null,
    BalanceOf: 0.3421064596,
    PricePerFullShare: 1.0,
    Balance: 0.3421064596,
    Reward: 0.1300680478,
    RewardToken: "AQUA",
    LpTokens:
      "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c,0x72b7d61e8fc8cf971960dd9cfa59b8c829d91991",
    LpTokensUsd: "472.5,1902.4",
    BalanceUsd: 406.2343154402,
    RewardTokensUsd: "1902.4",
    RewardUsd: 247.4414541864,
    TotalUsd: 653.6757696266,
  },
  {
    Datetime: "2021-10-17 14:03:05",
    id: 401,
    Wallet: "0x7f...C63c",
    Name: "FantomSpookyFtmBnb",
    Blockchain: "Fantom",
    Platform: "SpookySwap",
    Vault: "FTM-BNB",
    Uses: null,
    BalanceOf: 0.0000213863,
    PricePerFullShare: 1.4399089695,
    Balance: 0.0000307943,
    Reward: 0.0,
    RewardToken: null,
    LpTokens:
      "0x21be370d5312f44cb42ce377bc9b8a0cef1a4c83,0xd67de0e0a0fd7b15dc8348bb9be742f3c5850454",
    LpTokensUsd: "2.27,0",
    BalanceUsd: 0.0,
    RewardTokensUsd: null,
    RewardUsd: 0.0,
    TotalUsd: 0.0,
  },
  {
    Datetime: "2021-10-17 14:03:05",
    id: 12,
    Wallet: "0x7f...C63c",
    Name: "BscBeefy",
    Blockchain: "BSC",
    Platform: "Beefy",
    Vault: "AUTO-BNB LP",
    Uses: "PancakeSwap (Autofarm) / Autofarm",
    BalanceOf: 0.7624876416,
    PricePerFullShare: 1.948453082,
    Balance: 1.4856713952,
    Reward: 0.0,
    RewardToken: null,
    LpTokens:
      "0xa184088a740c695e156f91f5cc086a06bb78b827,0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
    LpTokensUsd: "1199.49,472.5",
    BalanceUsd: 1242.0138580606,
    RewardTokensUsd: null,
    RewardUsd: 0.0,
    TotalUsd: 1242.0138580606,
  },
  {
    Datetime: "2021-10-17 14:03:05",
    id: 13,
    Wallet: "0x7f...C63c",
    Name: "BscBeefy",
    Blockchain: "BSC",
    Platform: "Beefy",
    Vault: "MATIC-BNB LP",
    Uses: "ApeSwap",
    BalanceOf: 21.798162132,
    PricePerFullShare: 1.2171956798,
    Balance: 26.5326287738,
    Reward: 0.0,
    RewardToken: null,
    LpTokens:
      "0xcc42724c6683b7e57334c4e856f4c9965ed682bd,0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
    LpTokensUsd: "1.52,472.5",
    BalanceUsd: 6288.4983456706,
    RewardTokensUsd: null,
    RewardUsd: 0.0,
    TotalUsd: 6288.4983456706,
  },
  {
    Datetime: "2021-10-17 14:03:05",
    id: 14,
    Wallet: "0x7f...C63c",
    Name: "BscBeefy",
    Blockchain: "BSC",
    Platform: "Beefy",
    Vault: "1INCH",
    Uses: "1Inch",
    BalanceOf: 46.5216074056,
    PricePerFullShare: 1.1367072513,
    Balance: 52.8814484806,
    Reward: 0.0,
    RewardToken: null,
    LpTokens: "0x111111111117dc0aa78b770fa6a738034120c302",
    LpTokensUsd: "3.35",
    BalanceUsd: 177.1528524101,
    RewardTokensUsd: null,
    RewardUsd: 0.0,
    TotalUsd: 177.1528524101,
  },
  {
    Datetime: "2021-10-17 14:03:05",
    id: 15,
    Wallet: "0x7f...C63c",
    Name: "BscBeefy",
    Blockchain: "BSC",
    Platform: "Beefy",
    Vault: "SWAMP",
    Uses: "Swamp / Other",
    BalanceOf: 39.9211353527,
    PricePerFullShare: 3.4925715964,
    Balance: 139.4274234286,
    Reward: 0.0,
    RewardToken: null,
    LpTokens: "0xc5a49b4cbe004b6fd55b30ba1de6ac360ff9765d",
    LpTokensUsd: "0.988725",
    BalanceUsd: 137.8553792294,
    RewardTokensUsd: null,
    RewardUsd: 0.0,
    TotalUsd: 137.8553792294,
  },
  {
    Datetime: "2021-10-17 14:03:05",
    id: 16,
    Wallet: "0x7f...C63c",
    Name: "BscBeefy",
    Blockchain: "Avax",
    Platform: "Beefy",
    Vault: "SYN-AVAX LP",
    Uses: "Trader Joe",
    BalanceOf: 35.7192792915,
    PricePerFullShare: 1.1700291312,
    Balance: 41.7925973149,
    Reward: 0.0,
    RewardToken: null,
    LpTokens:
      "0x1f1E7c893855525b303f99bDF5c3c05Be09ca251,FvwEAhmxKfeiG8SnEvq42hc6whRyY3EFYAvebMqDNDGCgxN5Z",
    LpTokensUsd: "2.85,58.13",
    BalanceUsd: 1274.2562921315,
    RewardTokensUsd: null,
    RewardUsd: 0.0,
    TotalUsd: 1274.2562921315,
  },
  {
    Datetime: "2021-10-17 14:03:05",
    id: 101,
    Wallet: "0x7f...C63c",
    Name: "EthOlympusOhm",
    Blockchain: "Ethereum",
    Platform: "Olympus",
    Vault: "OHM",
    Uses: null,
    BalanceOf: 1.942833746,
    PricePerFullShare: 1.0,
    Balance: 1.942833746,
    Reward: 0.0,
    RewardToken: null,
    LpTokens: "0x383518188c0c6d7730d91b2c03a03c837814a899",
    LpTokensUsd: "932.05",
    BalanceUsd: 1810.8181929593,
    RewardTokensUsd: null,
    RewardUsd: 0.0,
    TotalUsd: 1810.8181929593,
  },
  {
    Datetime: "2021-10-17 14:03:06",
    id: 1,
    Wallet: "0x68...4ff6",
    Name: "BscAutofarm_1",
    Blockchain: "BSC",
    Platform: "Autofarm",
    Vault: "BUSD-VAI LP",
    Uses: null,
    BalanceOf: 13.7978446416,
    PricePerFullShare: 1.0,
    Balance: 13.7978446416,
    Reward: 0.0008297291,
    RewardToken: "pAUTO",
    LpTokens:
      "0x4bd17003473389a42daf6a0a729f6fdb328bbbd7,0xe9e7cea3dedca5984780bafc599bd69add087d56",
    LpTokensUsd: "0.981365,1",
    BalanceUsd: 13.6692832242,
    RewardTokensUsd: "1199.49",
    RewardUsd: 0.9952517715,
    TotalUsd: 14.6645349956,
  },
];

export const userData = [
  {
    name: "Jan",
    "Active User": 4000,
    pv: 2400,
    amt: 2400,
  },
  {
    name: "Feb",
    "Active User": 3000,
    pv: 1398,
    amt: 2210,
  },
  {
    name: "Mar",
    "Active User": 2000,
    pv: 9800,
    amt: 2290,
  },
  {
    name: "Apr",
    "Active User": 2780,
    pv: 3908,
    amt: 2000,
  },
  {
    name: "May",
    "Active User": 1890,
    pv: 4800,
    amt: 2181,
  },
  {
    name: "Jun",
    "Active User": 2390,
    pv: 3800,
    amt: 2500,
  },
  {
    name: "Jul",
    "Active User": 3490,
    pv: 4300,
    amt: 2100,
  },
  {
    name: "Aug",
    "Active User": 4090,
    pv: 4300,
    amt: 2100,
  },
  {
    name: "Sep",
    "Active User": 490,
    pv: 4300,
    amt: 2100,
  },
  {
    name: "Oct",
    "Active User": 2490,
    pv: 4300,
    amt: 2100,
  },
  {
    name: "Nov",
    "Active User": 1490,
    pv: 4300,
    amt: 2100,
  },
  {
    name: "Dec",
    "Active User": 5490,
    pv: 4300,
    amt: 2100,
  },
];

export const productData = [
  {
    name: "Jan",
    "Sales": 2000,
  },
  {
    name: "Feb",
    "Sales": 1000,
  },
  {
    name: "Mar",
    "Sales": 3000,
    pv: 9800,
    amt: 2290,
  },
];

export const userRows = [
  {
    id: 1,
    username: "Jon Snow",
    avatar:
      "https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    email: "jon@gmail.com",
    status: "active",
    transaction: "$120.00",
  },
  {
    id: 2,
    username: "Jon Snow",
    avatar:
      "https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    email: "jon@gmail.com",
    status: "active",
    transaction: "$120.00",
  },
  {
    id: 3,
    username: "Jon Snow",
    avatar:
      "https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    email: "jon@gmail.com",
    status: "active",
    transaction: "$120.00",
  },
  {
    id: 4,
    username: "Jon Snow",
    avatar:
      "https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    email: "jon@gmail.com",
    status: "active",
    transaction: "$120.00",
  },
  {
    id: 5,
    username: "Jon Snow",
    avatar:
      "https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    email: "jon@gmail.com",
    status: "active",
    transaction: "$120.00",
  },
];

export const productRows = [
  {
    id: 1,
    name: "Apple Airpods",
    img:
      "https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    stock: 123,
    status: "active",
    price: "$120.00",
  },
  {
    id: 2,
    name: "Apple Airpods",
    img:
      "https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    stock: 123,
    status: "active",
    price: "$120.00",
  },
  {
    id: 3,
    name: "Apple Airpods",
    img:
      "https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    stock: 123,
    status: "active",
    price: "$120.00",
  },
  {
    id: 4,
    name: "Apple Airpods",
    img:
      "https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    stock: 123,
    status: "active",
    price: "$120.00",
  },
  {
    id: 5,
    name: "Apple Airpods",
    img:
      "https://images.pexels.com/photos/7156886/pexels-photo-7156886.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
    stock: 123,
    status: "active",
    price: "$120.00",
  },
];
